import React from 'react';
import LegalPageLayout from '../components/legal/LegalPageLayout';
import { privacyPolicy } from '../content/legalContent';
import { Box } from '@chakra-ui/react';
import { GlobalFooter } from '../components/ui/GlobalFooter';

const Privacy: React.FC = () => {
  return (
    <>
      <LegalPageLayout title="Privacy Policy">
        {privacyPolicy}
      </LegalPageLayout>
      <Box px={{ base: 4, md: 8 }} pb={8}>
        <GlobalFooter />
      </Box>
    </>
  );
};

export default Privacy;
